import markdownit from 'markdown-it';
import { useMemo } from 'react';

const md = markdownit();

export interface MarkdownProps {
    source?: string|null;
    className?: string;
}

export const Markdown: React.FC<MarkdownProps> = ({ source, className }) => {
    const html = useMemo(
        () => source ? md.render(source) : null,
        [source]
    );

    if (!html) {
        return null;
    }

    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};
